import React from 'react'
import Nav from '../Pages/Nav/Nav'
import { Box, Toolbar } from '@mui/material'
import Footer from '../Pages/mainPage/Footer'

const ProtectedRoutes = (props) => {
  return (
    <Box>
        <Nav/>
        <Box sx={{ mt: "-10vh" }} >
            <Toolbar/>
            
            {props.children}
           

        </Box>
        <Footer/>
    </Box>
  )
}

export default ProtectedRoutes